import {handleActions} from 'redux-actions';
import {Map, OrderedMap} from 'immutable';

import InstitutionPreview from './model';
import * as Actions from './actions';
import * as InstitutionsActions from '../institutions/typed-actions';

export default handleActions(
    {
        [Actions.fetchAllSuccess.type]: (state, {payload}) => {
            const institutionMap = OrderedMap(payload.institutions.map(inst => [inst.institutionId, inst]));
            return state.merge(institutionMap);
        },

        [InstitutionsActions.fetchBehaviorsSuccess.type]: (state, {payload}) => {
            return state.update(payload.institutionId, InstitutionPreview.default, inst =>
                inst.merge({behaviors: payload.behaviors}),
            );
        },
    },
    Map(),
);
